import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Hidden, Checkbox, FormControlLabel, Switch, IconButton  } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import DocStore from '../../stores/DocStore'
import EmptyTable from '../EmptyTable'
import FloatIndexActions from '../FloatIndexActions'
import { withRouter } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import InfiniteLoader from 'react-infinite-loader'
import RevisionIcon from '@material-ui/icons/Check'
import PendingIcon from '@material-ui/icons/AccessTime'
import Attachment from '@material-ui/icons/Attachment'
import Event from '@material-ui/icons/Event'
import FilterList from '@material-ui/icons/FilterList'
import Highlighter from "react-highlight-words";
import { TFAVerify } from "../2FA";
import generatePDF from '../../functions/generatePDF'
import moment from 'moment'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import ArrowUpward from '@material-ui/icons/ArrowUpward'
import { Check, Close } from '@material-ui/icons'
import { DownloadReport } from "../../img";
import withSnack from '../withSnack'
import { CustomTooltip } from '../CustomTooltip'

export class DocTable extends Component {
  onNewInbox = data => {
    this.setState(prevState => {
      const newState = {...prevState}
      newState.docs = [...prevState.docs]
      if (newState.docs.length === newState.rowsPerPage) newState.docs.pop()
      data.new = true
      newState.docs.unshift(data)
      if (prevState.count === 0) newState.count = 1
      return newState
    })
  }

  handleClickOpen = (e) => {
    this.setState({open: true, selected_id: e})
  }

  openDoc = (id) => {
    this.props.history.push('/oficios/' + id,  { previous: this.state.previous, tab: (typeof this.props.tab !== 'undefined')? Number(this.props.tab) : 0, page: Number(this.state.page) })
  }

  handleClose = () => {
    this.setState({open: false, selected_id: 0})
  }

  onDelete = id => {
    DocStore.delete(id).then(r => {
      let docs = [...this.state.docs]
      let foundIndex = docs.findIndex(x => x.id === id)
      docs.splice(foundIndex, 1)
      const {page,rowsPerPage} = this.state
      DocStore.fetch(this.props.fetch, rowsPerPage, page + 1).then(r => {
        this.setState({docs: r.data.docs, count: r.data.total, page: page })
      })
    })
    this.handleClose()
  }

  handleChangePage = (event, page) => {
    const {rowsPerPage} = this.state
    DocStore.fetch(this.props.fetch, rowsPerPage, page + 1, this.props.q).then(r => {
      this.setState({docs: this.state.filtered ? r.data.docs.sort((x, y) => x.read - y.read) : r.data.docs, count: r.data.total, page: page })
    })
  }

  handleChangeRowsPerPage = event => {
    const rowsPerPage = event.target.value
    const {page} = this.state
    DocStore.fetch(this.props.fetch, rowsPerPage, page, this.props.q).then(r => {
      this.setState({
        docs: this.state.filtered ? r.data.docs.sort((x, y) => x.read - y.read) : r.data.docs,
        count: r.data.total,
        rowsPerPage: rowsPerPage
      })
    })
  }

  labelDisplayRows = ({from, to, count}) => {
    return `${from}-${to} de ${count}`
  }

  handleCheck = (doc) => {
    if(this.state.ids.includes(doc.id)){
      this.setState(prevState => ({
        ids: [...prevState.ids.filter(element => element !== doc.id)],
        oficios: [...prevState.oficios.filter(oficio => oficio.id !== doc.id)]
      }))
    }
    else{
      const from = (typeof doc.full_from === 'undefined')? null : doc.full_from;
      const to = (typeof doc.full_to === 'undefined')? null : doc.full_to;

      this.setState(prevState => ({
        ids: [...prevState.ids, doc.id],
        oficios: [...prevState.oficios,
          {
            id: doc.id,
            folio: doc.folio,
            date: doc.date,
            from: ((typeof from.name.title !== 'undefined')? from.name.title : ' ') + ' ' + ((typeof from.name.full !== 'undefined')? from.name.full : ' ') + ' - ' + ((typeof from.job_title !== 'undefined')? from.job_title : ' ') + ' (' + ((typeof from.email !== 'undefined')? from.email : '') + ')',
            to: ((typeof to.name.title !== 'undefined')? to.name.title : ' ') + ' ' + ((typeof to.name.full !== 'undefined')? to.name.full : ' ') + ' - ' + ((typeof to.job_title !== 'undefined')? to.job_title : ' ') + ' (' + ((typeof to.email !== 'undefined')? to.email : '') + ')',
            content: doc.body,
            cc: doc.notice_user_list,
            subject: (typeof doc.subject !== 'string')? ' ' :  doc.subject
          }
        ]
      }))
    }
}

onMassiveSign = () => {
  this.setState({ modal2FA: true })
}

closeModal2FA = () => {
  this.setState({
    modal2FA: false
  });
};

updateDocs = (ordered) => {
  DocStore.fetch(
    this.props.fetch,
    this.state.rowsPerPage,
    this.state.page,
    this.props.q,
    ordered? 1 : 0
  ).then(r => {
    this.setState({
      docs: r.data.docs,
      count: r.data.total,
      isLoaded: true,
      q: ''
    })
  })
}

onGoodCode = (ids, rowsPerPage, page, oficios) => {
  DocStore.mass_sign(ids, rowsPerPage, page).then(r => {
    this.setState(prevState => {

      oficios.forEach((item) => {
        generatePDF(item)
      });

      this.setState({ ids: []})
      this.updateDocs()
    })
  })
    .catch((error) => {
    })
};

  constructor (props) {
    super(props)
    this.state = {
      docs: [],
      isLoaded: false,
      page: (typeof this.props.page !== 'undefined')? Number(this.props.page) : 0,
      rowsPerPage: 10,
      count: 0,
      open: false,
      ids: [],
      modal2FA: false,
      oficios: [],
      filtered: false,
      ordered: ''
    }
  };

  componentDidMount () {
    document.title = "GO | " + this.props.title;
    const { page } = this.state
    this.updateDocs()
    if (this.props.fetch === 'inbox'|| this.props.fetch === 'review' || this.props.fetch === 'pending' || this.props.fetch === 'pass' || this.props.fetch === 'approve')
      this.subs = DocStore.getInboxChannel(this.onNewInbox)

    let previous = 'recibidos'
    switch (this.props.fetch){
      case "inbox":
      case "review":
      case "pass":
      case "physical":
        previous = 'recibidos'
      break;

      case "sent":
      case "pending":
      case "approve":
        previous = 'enviados'
      break;

      case ('draft'):
        previous = 'borradores'
      break;

      default:
      break;
    }

    this.setState({ previous: previous })

    if(page > 0){
      this.handleChangePage('', page)
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.q !== prevProps.q)
      this.updateDocs()
  }

  loadList (rows, count) {
    if(rows < count){
      rows  += 10
      DocStore.fetch(this.props.fetch, rows, 0).then(r => {
        this.setState({
          docs: r.data.docs,
          count: r.data.total,
          rowsPerPage: rows
        })
      })
    }
  }

  cut_text = (text) => {
    return text.substring(0,30)
  }

  orderBy = (order, reset) => {
    const { filtered, docs } = this.state;

    if(reset){
      this.setState({ filtered: false, ordered: ''})
      this.updateDocs(false)
    }
    else{
      this.setState({ filtered: !filtered, ordered: order})
      this.updateDocs(true)
    }
  }

  downloadReport = () =>{

    DocStore.download().then(
      r => {
        if (r.status === 200) {
          let link = document.createElement('a');
            link.href = window.URL.createObjectURL(r.data);
            link.download = `reporte_oficios.xlsx`;
            link.click();
        }
        else{
          this.props.snack('Ocurrió un error al descargar el reporte', 'warning')
        }
      },
      e => {
          this.props.snack('Ocurrió un error al generar el reporte', 'warning')
      }
    )
  }

  render () {
    if (!this.state.isLoaded) return null
    const {fetch, q} = this.props
    const {docs, rowsPerPage, page, count, ids, modal2FA, oficios, filtered, ordered } = this.state
    // const emptyRows =
    //   rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage)
    const sentTable = fetch === 'sent'
    const review = (this.props.fetch === 'review')
    const approve = (this.props.fetch === 'approve')
    const pass = (this.props.fetch === 'pass')
    const pending = (this.props.fetch === 'pending')
    const draft = (this.props.fetch === 'draft')
    const inbox = (this.props.fetch === 'inbox')
    const physical = (this.props.fetch === 'physical')
    const all = (this.props.fetch === 'all')
    const rowOptions = (count <= 10)?  [0,10] :(count <= 25)?  [10,25] : (count >= 25)? [10,25,50]:[10,25,50,100]
    const disableArrows = (count <= 10)
    let massiveSign = '';
    if (review){
        massiveSign = (
          <Button
            onClick={() => this.onMassiveSign()}
            disabled= {ids.length > 0? false : true }
            color="primary"
            variant="contained" >
            Firmar y enviar seleccionados
          </Button>
        )
    }

    let orderByread = null;

    if(inbox){
      orderByread = (
        <FormControlLabel
          control={
            <Switch
              checked={filtered? true : false}
              onChange={() => this.orderBy('read', filtered)}
              name="external"
              color="primary"
            />}
            label={<Typography variant="subtitle1">Ordenar por oficios no leídos</Typography>}
          />
      );
    }

    let downloadButton = null;

    if(inbox || sentTable){
      downloadButton = (
        <CustomTooltip  title="Descargar reporte" placement="right">
          <IconButton
            onClick={this.downloadReport}
            color="primary"
            className="downloadBtn">
              <DownloadReport />
          </IconButton>
        </CustomTooltip>
      );
    }

    const actionsButtons = (
      <div style={{ textAlign: 'right', marginTop: inbox || sentTable? '-50px' : 0 }}>
        {orderByread}
        {downloadButton}
        {/* <FormControlLabel
          control={
            <Switch
              checked={(ordered === '' && filtered === false)? false : true}
              onChange={() => this.orderBy('', true)}
              name="external"
              color="primary"
              disabled={(ordered === '' && filtered === false)? true : false}
            />}
            label={<Typography variant="subtitle1">Quitar filtro</Typography>}
          /> */}
      </div>
    );

    return (
      <React.Fragment>
          {count >= 1 ? (
            <div>
              <Hidden only={['xs','sm']}>
              {actionsButtons}
              <Table padding="none" spacing={0} align="nowrap" className={'indexTable'}>
                <TableHead>
                  <TableRow>
                    {review? <TableCell style={{width: '3%'}}></TableCell> : null }
                    <TableCell padding={'checkbox'} style={draft || inbox || all?{width: '10%'} : {width: '8%'}}>
                      <RenderFilters option="folio" desc="Folio" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                    </TableCell>
                    {(inbox || sentTable) ?
                      <TableCell style={{width: '8%'}}>
                        <RenderFilters option="date" desc="Fecha de creación" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                      </TableCell>
                      : null}
                    <TableCell style={draft || inbox || all?{width: '20%'} : {width: '18%'}}>
                        <RenderFilters option="from" desc="De" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                    </TableCell>
                    <TableCell style={draft || inbox || all?{width: '20%'} : {width: '18%'}}>
                      <RenderFilters option="to" desc="Para" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                    </TableCell>
                    <Hidden smDown>
                      <TableCell style={{width: '18%'}}>
                        <RenderFilters option="created_by" desc="Creado por" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                      </TableCell>
                    </Hidden>
                    {(pending || review || pass || approve) ?
                      <TableCell style={{width: '8%'}}>
                        <RenderFilters option="notes" desc="Estado" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                      </TableCell>
                      : null}
                      <TableCell style={{width: '15%'}}>
                        <RenderFilters option="subject" desc="Asunto" ordered={ordered} filtered={filtered} orderBy={this.orderBy} />
                      </TableCell>
                      {(physical) ?
                        <TableCell style={{width: '6%'}}>Enviado</TableCell>
                        : null}
                    {(all) ?
                      <TableCell style={{width: '20%'}}>Contenido</TableCell>
                      : null}
                    {sentTable ? <TableCell style={{width: '4%'}}>Visto por</TableCell> : null}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {docs.map(d => {
                    return (
                      <TableRow key={d.id} className={
                        (
                         (physical && d.physical_request) ||
                         ((d.is_reviewer && !d.accepted) && inbox) ||
                         (d.new) ||
                         (!d.read && inbox && !d.is_reviewer) ||
                         (review && !d.notes) ||
                         (pass && !d.notes) ||
                         (approve && d.notes) ||
                         (pending && d.notes) ||
                         (!d.read && fetch === "all" && d.sent === '')) ? ' alert' : null}
                                onClick={(e) => this.openDoc(d.id)}
                      >
                        {review? <TableCell><Checkbox disabled={d.notes ? true : false } className="test" onClick={(e) => {
                          e.stopPropagation()
                          this.handleCheck(d)
                        }
                      } /></TableCell> : null }
                        <TableCell padding={'checkbox'}>{d.folio}</TableCell>
                        {(inbox || sentTable) ?
                          <TableCell style={{width: '8%'}}>{moment(d.date).format('DD/MM/YYYY')}</TableCell>
                          : null}
                        <TableCell>{d.from}</TableCell>
                        <TableCell>{d.to}</TableCell>
                        <Hidden smDown>
                          <TableCell>{d.created_by}</TableCell>
                        </Hidden>

                        {(pending || review || pass || approve) ? (
                          <TableCell> {d.notes ? 'Revisado' : 'Pendiente'}</TableCell>
                        ) : null}
                            <TableCell>{(typeof d.subject === 'string')? this.cut_text(d.subject) : ''}</TableCell>
                            {physical ? (
                              <TableCell>
                                {!d.physical_request? <Check className="tick" /> : <Close className="tick"/> }
                              </TableCell>
                            ) : null}
                          {(!all) ? null :
                            (
                              <TableCell>
                              {d.extract.length > 30 ?
                                  this.cut_text(d.extract) :
                                      d.extract !=='(sin texto)' && d.inextract ?
                                      <Highlighter
                                        highlightClassName="highlight"
                                        searchWords={[q]}
                                        autoEscape={true}
                                        textToHighlight={this.cut_text(d.extract)}
                                      /> :
                                      <p>{this.cut_text(d.extract)}</p>}
                            </TableCell>
                            ) }
                        {sentTable ? (<TableCell><p>{d.read_count + " de "+ d.total_sent}</p></TableCell>) : null}
                        <TableCell style={{color:'gray', transform:'scale(.9)', textAlign:'right'}}>{d.has_attachment? <Attachment style={{marginRight:'1em'}} />: <span style={{minWidth: '72px', paddingRight:'2em'}}/>}<span>{d.has_event? <Event />: <span style={{minWidth: '72px'}}/>}</span></TableCell>
                        <TableCell className={'actionsFloat'}>
                          <FloatIndexActions
                            helperText={
                              pending && d.notes ? 'Atender' :
                                review && d.notes ? 'Ver' :
                                  review ? 'Revisar' :
                                    draft ? 'Editar' : 'Ver'
                            }
                            d={d}
                            deleteOption={!!(((!d.sent.length) && (draft)) || ((pending) && (d.notes)))}
                            handleClickOpen={this.handleClickOpen}
                            openDoc={this.openDoc}
                          >
                          </FloatIndexActions>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      colSpan={4}
                      count={count}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      labelDisplayedRows={this.labelDisplayRows}
                      labelRowsPerPage="Resultados por página"
                      rowsPerPageOptions={
                        rowOptions}
                      SelectProps={{
                        'disabled': disableArrows,
                      }}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
              {massiveSign}
            </Hidden>
            <Hidden only={['md','lg','xl']}>
              {docs.map(d => {
                return (
                  <List className="list_main" key={d.folio}>
                    <ListItem alignItems="flex-start" button onClick={(e) => this.openDoc(d.id)}>
                      <ListItemText
                        className={
                          (
                           (physical && d.physical_request) ||
                           ((d.is_reviewer && !d.accepted) && inbox) ||
                           (d.new) ||
                           (!d.read && inbox && !d.is_reviewer ) ||
                           (review && !d.notes) ||
                           (pass && !d.notes) ||
                           (approve && d.notes) ||
                           (pending && d.notes) ||
                           (!d.read && fetch === "all" && d.sent === '')) ? ' desc_list_unread' : 'desc_list_read'}
                        primary={
                          <React.Fragment>
                            <Typography component="span">
                              {d.from}
                              <span className="date_list">
                                {(review || pending? d.notes ? <RevisionIcon/> : <PendingIcon/>   : null)}
                              </span>
                            </Typography>
                          </React.Fragment>
                        }
                        secondary={
                          <React.Fragment>
                            <Typography component="span">
                              {d.folio}
                            </Typography>
                            <Typography component="span">
                              {moment(d.date).format('DD/MM/YYYY')}
                            </Typography>
                            <Typography component="span">
                              {'Para: '+d.to}
                            </Typography>
                            <Typography component="span" style={{overflow: 'hidden'}}>
                                {`Asunto: ${ (typeof d.subject === 'string')? d.subject : 'Sin asunto' }`}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider/>
                </List>
                )
              })}
              <InfiniteLoader onVisited={ () => this.loadList(rowsPerPage, count) } />
            </Hidden>
            </div>
          ) : (
            <EmptyTable
              title={this.props.title}
              src={this.props.fetch}
            />
          )}
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
          >
            <DialogTitle id="draggable-dialog-title">Confirmación</DialogTitle>
            <DialogContent>
              ¿Realmente desea eliminar el oficio?
            </DialogContent>
            <DialogActions className="button_modal">
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={() => this.onDelete(this.state.selected_id)} color="primary">
                Eliminar
              </Button>
            </DialogActions>
          </Dialog>
          <TFAVerify
            open={modal2FA}
            onClose={this.closeModal2FA}
            onContinue={() => this.onGoodCode(ids, rowsPerPage, page, oficios)}/>
      </React.Fragment>
    )
  }
}

const RenderFilters = (props) => {
  const { ordered, option, filtered, desc, orderBy } = props;

    return(
      <React.Fragment>
        {/* <IconButton className={(ordered === option)? "filterIcon activeIcon" : "filterIcon"} onClick={(e) => orderBy(option)}>
          {(ordered === option)? filtered? <ArrowUpward/> : <ArrowDownward/> : <FilterList/>}
        </IconButton> */}
        {desc}
      </React.Fragment>
    )
}

DocTable.propTypes = {
  fetch: PropTypes.string.isRequired
}

export default withSnack((withRouter(DocTable)));



// WEBPACK FOOTER //
// ./src/components/containers/DocTable.js